export default (nextState, replaceState) => {
  const profileId = nextState.params.profileId;
  const page = nextState.params.page;

  switch (page) {
    case 'assessments':
      replaceState({}, `/admin/Qualified/${profileId}/Profile/Preliminary%20Information?detail=1&edit=2`);
      break;
    case 'resume':
      replaceState({}, `/admin/Qualified/${profileId}/Profile/Preliminary%20Information/resume`);
      break;
    case 'resume-pdf':
        replaceState({}, `/api/applicants/${profileId}/pdf/${process.env.CRON_SECRET}`);
        break;
    default:
      replaceState({}, '/');
      break;
  }
}



// WEBPACK FOOTER //
// ./shared/utils/bullhornRedirect.js